export default __webpack_public_path__ + "static/dub-d93f92bb09cfa79b669029edf2c96507.jpeg";